"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.encloseInMjmlSection = exports.toMjml = void 0;

var _formatDefinition = require("./formatDefinition");

var toMjml = function toMjml(mjElement, edieProps, ediePropsDefinition) {
  var body = '';
  var propsAsText = '';
  var computedProp;
  Object.keys(ediePropsDefinition || {}) // Handle only attributes with value
  .filter(function (k) {
    return edieProps[k] || ediePropsDefinition[k].type === _formatDefinition.EDIE_PROP_TYPE.COMPUTED;
  }).forEach(function (key) {
    var edieKeyDefinition = ediePropsDefinition[key];

    if (!edieKeyDefinition) {
      // console.warn(`No definition found for creating '${mjElement}' and property '${key}'` );
      return;
    }

    switch (edieKeyDefinition.type) {
      //
      case _formatDefinition.EDIE_PROP_TYPE.BODY:
        body = edieProps[key];
        break;

      case _formatDefinition.EDIE_PROP_TYPE.ATTRIBUTE:
        propsAsText = propsAsText + ' ' + key + '="' + edieProps[key] + '"';
        break;

      case _formatDefinition.EDIE_PROP_TYPE.TRANSLATED:
        propsAsText = propsAsText + ' ' + ediePropsDefinition[key].mjAttribute + '="' + edieProps[key] + '"';
        break;

      case _formatDefinition.EDIE_PROP_TYPE.COMPUTED:
        computedProp = ediePropsDefinition[key].compute(edieProps);

        if (computedProp) {
          propsAsText = propsAsText + ' ' + computedProp.key + '="' + computedProp.value + '"';
        }

        break;
    }
  });

  if (ediePropsDefinition.__selfClosing) {
    return "<".concat(mjElement, " ").concat(propsAsText.trim(), "/>\r\n");
  }

  return "<".concat(mjElement, " ").concat(propsAsText.trim(), ">").concat(body, "</").concat(mjElement, ">\r\n");
};

exports.toMjml = toMjml;

var propertiesToText = function propertiesToText(props, keysToIgnore) {
  var properties = '';
  Object.keys(props || {}).filter(function (key) {
    return !(keysToIgnore || []).includes(key);
  }).forEach(function (key) {
    // TODO FIX: Make sure props[key] is escaped !!!
    if (props[key]) {
      properties = properties + ' ' + key + '="' + props[key] + '"';
    }
  });
  return properties.trim();
};

var encloseInMjmlSection = function encloseInMjmlSection(item, addtionalSectionProps) {
  if (!addtionalSectionProps) {
    return "<mj-section padding=\"0px\"><mj-column padding=\"0px\">".concat(item, "</mj-column></mj-section>");
  }

  return "<mj-section padding=\"0px\" ".concat(propertiesToText(addtionalSectionProps), "><mj-column padding=\"0px\">").concat(item, "</mj-column></mj-section>");
};

exports.encloseInMjmlSection = encloseInMjmlSection;